import {
  MealCountDto,
  SaveMealCountRequest,
  MealCountStatus, 
  MergeServingLineRequest
} from "@/models";

export interface IMealState {
  mealCountDtos: MealCountDto[];
  mealCountStatuses: MealCountStatus[];
  lastSyncUtc: Date;
  syncUpCounts: SaveMealCountRequest[];
  tempDto: MealCountDto[];
  mergeServingLines: MergeServingLineRequest[];
}

export class MealState implements IMealState {
  mealCountDtos: MealCountDto[] = [];
  mealCountStatuses: MealCountStatus[] = [];
  lastSyncUtc: Date = new Date();
  syncUpCounts: SaveMealCountRequest[] = [];
  tempDto: MealCountDto[] = [];
  mergeServingLines: MergeServingLineRequest[] = [];
}
